<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  [options]="options"
  [selectedItems]="selectedValues"
  (selectedItemsChange)="onSelectedChange($event)"
  [class]="(isError ? 'ng-invalid ng-dirty ' : '') + (class || '')"
  [styleClass]="(isError ? 'ng-invalid ng-dirty ' : '') + (styleClass || '')"
  [placeholder]="placeholder"
  [appendTo]="appendTo"
  [disabled]="disabled"
  [showClear]="showClear"
  optionLabel="name"
  optionValue="value"></crm-multi-select>
